import { Component, OnInit,  Renderer2, ElementRef,OnDestroy , ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { UserService } from '../user.service';

@Component({
  selector: 'echexpayment-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit , OnDestroy{

	busy :Subscription;
    public resetPassword: any = {};
    public validationPassword : boolean=false;
    public validationConfirmpassword : boolean=false;
    public invalidEmail : boolean=false;
	
	public match :  boolean=false;
	public minPassword :  boolean=false;
	
	public password: string;
	public password_confirmation: string;
	public token_val: string;

	show: boolean = false;
	showConfirm: boolean = false;
	public confirmpasswod : string;
	
	constructor(private userService: UserService,private elementRef: ElementRef, private renderer: Renderer2, private router: Router,  private toastr: ToastrService, private  route: ActivatedRoute) { }

	ngOnInit() {
		
	}

	ngOnDestroy() {
		this.toastr.clear();
	}

	@ViewChild('submitButton') submitButton: ElementRef;
	moveNext(nextInput: HTMLInputElement, number: number) {
		if(number === 2){
			if (this.submitButton && this.submitButton.nativeElement) {
				this.submitButton.nativeElement.focus();
				this.submitButton.nativeElement.click();
			}
			//  const saveButton = document.getElementById('submitButton') as HTMLElement;
			//  if (saveButton) {
			// 	 saveButton.focus();
			// 	 saveButton.click();
			//  }
		} else{
		 nextInput && nextInput.focus();
		}
	}

	ngAfterViewInit(){
	   this.renderer.selectRootElement('#Initialfocus').focus();
	}
	// click event function toggle
	showHidePassword() {
		this.show = !this.show;
	}

	showHideConfirmPassword() {
		this.showConfirm = !this.showConfirm;
	}
	
	eventHandler(){
          this.validationPassword = false;
          this.validationConfirmpassword = false;
          this.match = false;
          this.minPassword = false;
        }
       
		focusFirstInvalidControlPlus(): void {
			const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
			if (firstElementWithErrors) {
				firstElementWithErrors.focus();
			}
		}
    // Forgot password    
	forgotPassword(data) {
	  this.focusFirstInvalidControlPlus();   //focus field
	  if (data.value.new_password !== data.value.confirm_password) {
		this.confirmpasswod = 'Password and Confirm password do not match';
		return;
	  }

	  if(data.valid) {
		let model: any = data.value;
		this.validationPassword = false;
		this.validationConfirmpassword = false;
		this.match = false;
		this.minPassword = false;
		if(typeof model.new_password === 'undefined'  || model.new_password === null || model.new_password === ''){
		this.validationPassword = true;
			return false;
		}
		if(model.new_password.length < 8){
			this.minPassword = true;
			return false;
		}
		if(typeof model.confirm_password === 'undefined'  || model.confirm_password === null || model.confirm_password === ''){
			this.validationConfirmpassword = true;
			return false;
		}
		if(model.new_password != model.confirm_password){
			this.match = true;
			return false;
		}
		let params: any = this.route.snapshot.params;
			var url = this.router.url;
			var res = url.split("/");
			var str = res[1];
			var t =  res[2];
			//var t =  str1.substr(2);
			
			model.t = t;
			model.token = params.token;
			let responseData = <any>{};
			this.busy =  this.userService.forgotPassword(model).subscribe(
			response => {
				responseData = response;
				if(responseData.status === 'success') {
					this.toastr.success(responseData.message, 'Success!');
					this.router.navigate(['/login']);
				} else {
					this.toastr.error(responseData.message, 'Failed!');
				}
			},
			error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
			}
		);
		}
	  }
	  
  //Password validation
  containsUppercase(value: string): boolean {
    return /[A-Z]/.test(value);
  }
  
  containsLowercase(value: string): boolean {
    return /[a-z]/.test(value);
  }
  
  containsDigit(value: string): boolean {
    return /\d/.test(value);
  }
  
  containsSpecialCharacter(value: string): boolean {
    return /[!@#$%^&*]/.test(value);
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/resetpassword/resetpassword.component.ts